export const CONVERSATION_LANGUAGE_VARIABLE_NAME = 'Conversation Language';
const EMBED_SCRIPT_LANGUAGE_VARIABLE_NAME = 'Embed Script Language';

export const excludeEmbedScriptParamNames = [
  CONVERSATION_LANGUAGE_VARIABLE_NAME,
];
export const includeEmbedScriptParamNames = [
  EMBED_SCRIPT_LANGUAGE_VARIABLE_NAME,
];
